module.exports = __webpack_public_path__ + "static/media/hydroflow_blog_hero_1200x630.2fb2cc90.png";